import usePreferStaticUI from "@/lib/usePreferStaticUI";
import SparkleField from "./SparkleField";
import VaporOrbs from "./VaporOrbs";
import BackgroundPaths from "./BackgroundPaths";
import AnimatedMesh from "./AnimatedMesh";
import SmokeWisps from "./SmokeWisps";

/**
 * Composed ambient scene — vapor, smoke, paths, sparkles, optional mesh.
 */
export const SceneBackdrop = ({
  variant = "hero",
  sparkles = true,
  paths = true,
  mesh = false,
  smoke = false,
  meshPalette = "rose",
  sparkleCount = 10,
  className = "absolute inset-0 -z-10",
}) => {
  const staticUI = usePreferStaticUI();

  if (staticUI) {
    return (
      <div className={`pointer-events-none overflow-hidden ${className}`} aria-hidden="true">
        <div className="absolute inset-0 bg-gradient-to-br from-roseMilk/25 via-transparent to-lavenderFog/20" />
      </div>
    );
  }

  return (
    <div className={`pointer-events-none overflow-hidden ${className}`} aria-hidden="true">
      {mesh && <AnimatedMesh palette={meshPalette} opacity={0.4} />}
      <VaporOrbs variant={variant} />
      {smoke && <SmokeWisps count={variant === "hero" ? 5 : 3} />}
      {paths && <BackgroundPaths variant={variant === "page" ? "hero" : variant} className="absolute inset-0 w-full h-full opacity-80" />}
      {sparkles && <SparkleField count={sparkleCount} />}
    </div>
  );
};

export default SceneBackdrop;
